export function customCloseDaysUpdateTable(table) {
    // Check if dates are within current week
    // Check if a date is within range of custom closed dates
    function isDateInRange(date, start, end) {
        return date >= start && date <= end;
    }
    //Gets all closed dates in current week. If array is empty, return and don't update the table
    function getClosedDatesThisWeek(weekDates, closeStart, closeEnd) {
        return weekDates.filter(date => isDateInRange(date, closeStart, closeEnd));
    }

    const today = new Date();
    //update the table to not display opening hours on closed days
    const monday = new Date(today);
    const day = today.getDay();
    const diffToMonday = day === 0 ? -6 : 1 - day;

    monday.setDate(today.getDate() + diffToMonday); // Set to Monday of the current week

    // Get all dates for the current week starting from Monday
    let weekDates = [];
    for (let i = 0; i < 7; i++) {
        let date = new Date(monday);
        date.setDate(monday.getDate() + i);
        weekDates.push(startOfDay(date)); // Store dates in YYYY-MM-DD format
    }
    function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    }

    function endOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
    }

    let start = new Date(table.parentElement.querySelector('.js-close-start').textContent);
    let end = new Date(table.parentElement.querySelector('.js-close-end').textContent);

    // normalize
    start = startOfDay(start);
    end = endOfDay(end);
    let days = table.querySelectorAll('.day');
    const closedThisWeek = getClosedDatesThisWeek(weekDates, start, end)
    const closedPeriods = [
        { from: start, to: end }
    ];

    function isClosed(date) {
        const d = startOfDay(date);
        return d >= start && d <= end;
    }
    function stripTime(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    function formatLocalYmd(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    function applyClosures(startDate, endDate) {
        const dayIndexMap = { 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5, 0: 6 };

        for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
            const currentDate = startOfDay(d);
            const weekday = currentDate.getDay();
            const nodeIndex = dayIndexMap[weekday];

            if (isClosed(currentDate)) {
            days[nodeIndex].parentNode.classList.add("inactive");
            const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
            days[nodeIndex].parentNode.querySelector("td").textContent = isEnglish ? "Closed" : "Lukket";
            }
        }
    }
    if (closedThisWeek.length === 0) {
        return;
    }
        const weekStart = weekDates[0];
        const weekEnd = weekDates[6];
        const effectiveStart = stripTime(start > weekStart ? start : weekStart);
        const effectiveEnd = stripTime(end < weekEnd ? end : weekEnd);

    applyClosures(effectiveStart, effectiveEnd);
}

export default customCloseDaysUpdateTable;